import {Divider } from "@mui/material";
import { FC } from "react";
import {
  List,
  ListItem,
  ListItemSecondaryAction,
} from "@mui/material";
import {H4 } from "../components/Typography";

interface PortfolioDetailsProps {
  item: any;
}
const PortfolioDetails: FC<PortfolioDetailsProps> = ({ item }) => {

  return (
    <>
    <ListItem
      sx={{
        display: "flex",
        justifyContent: "space-between",
        py: 0.5,
        px: 2,
        mt: 1,
      }}
    >
      <H4>Security</H4>
      <H4>Holding Percentage</H4>
    </ListItem>
    <List>
      {item?.map((data:any) => (
        <>
          <ListItem
            key={data.key}
            disableGutters
            sx={{
              display: "flex",
              justifyContent: "space-between",
              py: 0.5,
              px: 2,
              pl:2,
              pt:1,pb:1,
              background: "#fff",
            }}
          >
            <H4 sx={{ minWidth: "50%" }}>{data.security}</H4>
            <ListItemSecondaryAction>
              <H4 sx={{ minWidth: "50%", mr: 2 }}>{data.holding_perc}</H4>
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
        </>
      ))}
    </List>
  </>
  );
};

export default PortfolioDetails;
